exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container, .deleteButton {\n  font-family: 'Dosis', sans-serif;\n  margin: .3rem;\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: 600;\n  transition: background-color .2s; }\n\n.colorDot {\n  width: 64px;\n  height: 64px;\n  border-radius: 100%;\n  transition: background-color .2s; }\n\n.deleteButton {\n  background: transparent;\n  cursor: pointer;\n  outline: none;\n  opacity: .5;\n  transition: opacity .2s; }\n  .deleteButton[hidden] {\n    visibility: hidden; }\n  .deleteButton:hover {\n    opacity: 1; }\n  .deleteButton img {\n    width: 2rem; }\n\n.colorInput {\n  font-family: 'Dosis', sans-serif;\n  outline: none;\n  margin: 0;\n  width: 100%;\n  background: none;\n  border: none;\n  font-size: 1.2rem;\n  font-weight: 300;\n  text-align: center;\n  text-transform: uppercase; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Thomas/Projekte/palettes/src/app/shared/components/color-card/color-card.component.scss
// module id = ../../../../../src/app/shared/components/color-card/color-card.component.scss
// module chunks = main